export enum ResponseStatus {
  SUCCESS = 'Success',
  FAILED = 'Failed'
}
